<template>
    <a aria-label="Lire le texte à voix haute" title="Lire le texte" :class="['cursor-pointer', isPlaying ? 'opacity-3' : '']"
        :disabled="isPlaying" @click="play">
        <template v-if="isPlaying">
            <AudioPlayerIcon class="text-success" />
        </template>
        <template v-else>
            🔊
        </template>
    </a>
</template>

<script>
import AudioPlayerIcon from './AudioPlayerIcon.vue';
export default {
    components: {AudioPlayerIcon},
    props: {
        url: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            audioElement: new Audio(),
            isPlaying: false,
        }
    },
    methods: {
        play() {
            this.isPlaying = true;
            this.audioElement.play();
        },
        onEnded() {
            this.isPlaying = false;
            console.log('ended')
        }
    },
    mounted() {
        this.audioElement.src = this.url;
        this.audioElement.addEventListener('ended', this.onEnded);
    }
}
</script>